import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';

import { MessageBoxFunctionalLayout } from 'wix-style-react';

class DeleteConfirmation extends PureComponent {
  static propTypes = {
    t: func.isRequired,
    onCancel: func.isRequired,
    onDelete: func.isRequired,
  };

  render = () => {
    const { t, onCancel, onDelete } = this.props;

    return (
      <MessageBoxFunctionalLayout
        title={<span>{t('delete-confirmation.dialog.modal.header')}</span>}
        confirmText={t('delete-confirmation.dialog.modal.delete')}
        cancelText={t('delete-confirmation.dialog.modal.cancel')}
        theme="red"
        onCancel={onCancel}
        onOk={onDelete}
      >
        <div>{t('delete-confirmation.dialog.modal.title')}</div>
      </MessageBoxFunctionalLayout>
    );
  };
}
export default translate()(DeleteConfirmation);
